<div class="office-text-selector">
  <div class="input-container">
    <div class="svg-office">
      <kt-svg-office></kt-svg-office>
    </div>
    <input
      #input
      type="text"
      [matAutocomplete]="auto"   
      [formControl]="officeControl"
      class="iatacass-input"
      maxlength="12"
      placeholder="Search office..."
      (input)="iataCassQuery$.next(input.value)"
      (focus)="iataCassQuery$.next(input.value)"
    >
    <mat-autocomplete 
      requireSelection
      #auto="matAutocomplete"
      [displayWith]="displayFn.bind(this)"
      panelWidth="500px"
      [autoSelectActiveOption]="true"
    >
      @if (input.value?.length > 0 && officeResults().length === 0) {
        <mat-option disabled>No suggestions available</mat-option>
      }
      @for (office of officeResults(); track office.id) {
        <mat-option
          [value]="office.id"
          class="office-result" 
          [class.selected]="office.id === +officeControl.value"
        >
          <h2 class="company-name">{{ office.company.companyName }}</h2>
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center" style="gap: 8px">
              @if (office.airports?.[0]?.airportCode) {
                <span class="origin-airport-code">{{ office.airports?.[0]?.airportCode }}</span>
              }
              <span class="office-country-name">{{ office.country.countryName }}</span>
            </div>
            <span class="iata-cass">{{ getIataCass(office) }}</span>
          </div>
        </mat-option>
      }
    </mat-autocomplete>
  </div>
</div>
